import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=4b185272&scoped=true"
import script from "./ProductView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=4b185272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b185272",
  null
  
)

export default component.exports